module.exports = __webpack_public_path__ + "img/awards-zhCn.84b7b61b.png";